"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellSummaryPopover = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const CellSummaryDetails_1 = require("./CellSummaryDetails");
const CellSummaryPopover = (props) => {
    return React.createElement(CellSummaryDetails_1.CellSummaryDetails, { CellSummary: props.CellSummary });
};
exports.CellSummaryPopover = CellSummaryPopover;
